@if ((loaded$ | async) == true) {
  <div class="userdata">
    <div data-testid="formContainer" [formGroup]="userDataForm" class="userDataRow" [ngClass]="(TRANSLATE_PATH_PROJECT.USERDATA_DISPLAY_DIRECTION | translate) == DISPLAY_DIRECTION.FLEX ? 'flex row' : 'grid grid-4'">
      @if (isFirstname) {
        <app-field-item-text-input [fieldItem]="{attribute_1: TRANSLATE_PATH_PROJECT.USERDATA_FIRSTNAME | translateDesign}"  [formControlName]="FC_CONTROLS_USERDATAFROM.FIRSTNAME" [clearValueIfDisabled]="false"></app-field-item-text-input>
      }
      @if (isLastname) {
        <app-field-item-text-input [fieldItem]="{attribute_1: TRANSLATE_PATH_PROJECT.USERDATA_LASTNAME | translateDesign}"  [formControlName]="FC_CONTROLS_USERDATAFROM.LASTNAME" [clearValueIfDisabled]="false"></app-field-item-text-input>
      }
      @for (account of bankaccounts; track account; let i = $index) {
			<app-field-item-text-input [fieldItem]="{attribute_1: TRANSLATE_PATH_PROJECT.USERDATA_BANKACCOUNT | translateDesign}"  [formControlName]="FC_CONTROLS_USERDATAFROM.BANKACCOUNT + (i+1)" [clearValueIfDisabled]="false"></app-field-item-text-input>
      }
      @if (isCustomer) {
			<app-field-item-text-input [fieldItem]="{attribute_1: TRANSLATE_PATH_PROJECT.USERDATA_CUSTOMER | translateDesign}"  [formControlName]="FC_CONTROLS_USERDATAFROM.CUSTOMER" [clearValueIfDisabled]="false"></app-field-item-text-input>
      }
    </div>
    <div>
      <mat-divider></mat-divider>
    </div>
  </div>
}

